module.exports = __webpack_public_path__ + "static/media/2.3ab6d689.jpg";